export const APP_VERSION = '3.0.0';
